import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home/Home.vue'
import Login from '@/views/Login/login.vue'
import carbonSinkResources from '@/views/Home/carbonSinkResources/carbonSinkResources.vue'
import dataImport from '@/views/Home/dataImport/dataImport.vue'
import activitiesAndTravels from '@/views/Home/activitiesAndTravels/activitiesAndTravels.vue'
import policyInformation from '@/views/Home/policyInformation/policyInformation.vue'
import personnelInformation from '@/views/Home/personnelInformation/personnelInformation.vue'
import contributionStatistics from '@/views/Home/contributionStatistics/contributionStatistics.vue'
import carbonUptake from '@/views/Home/carbonUptake/carbonUptake.vue'
import classDetails from '@/views/Home/classDetails/classDetails.vue'
import userManagement from '@/views/Home/userManagement/userManagement.vue'
import carbonLabeling from '@/views/Home/carbonLabeling/carbonLabeling.vue'
import treePlanting from '@/views/Home/treePlanting/treePlanting.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/Home',
    name: 'Home',
    component: Home,
    redirect:carbonUptake,
    children:[
      // 碳汇资源管理平台
      {
        path: '/carbonSinkResources',
        name: 'carbonSinkResources',
        component: carbonSinkResources,
      },
      // 数据导入
      {
        path: '/dataImport',
        name: 'dataImport',
        component: dataImport,
      },
      // 零碳活动、零碳出行
      {
        path: '/activitiesAndTravels',
        name: 'activitiesAndTravels',
        component: activitiesAndTravels,
      },
      // 政策信息
      {
        path: '/policyInformation',
        name: 'policyInformation',
        component: policyInformation,
      },
      // 零碳+N
      {
        path: '/carbonUptake',
        name: 'carbonUptake',
        component: carbonUptake,
      },
      // 人员信息
      {
        path: '/personnelInformation',
        name: 'personnelInformation',
        component: personnelInformation,
      },
      // 零碳公司日
      {
        path: '/contributionStatistics',
        name: 'contributionStatistics',
        component: contributionStatistics,
      },
      // 零碳课堂明细
      {
        path: '/classDetails',
        name: 'classDetails',
        component: classDetails,
      },
      // 碳标签
      {
        path: '/carbonLabeling',
        name: 'carbonLabeling',
        component: carbonLabeling,
      },
      // 零碳植树
      {
        path: '/treePlanting',
        name: 'treePlanting',
        component: treePlanting,
      },
      // 用户管理
      {
        path: '/userManagement',
        name: '/userManagement',
        component: userManagement,
      }
    ]

  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: function () {
  //     return import(/* webpackChunkName: "about" */ '../views/About.vue')
  //   }
  // }
]

const router = new VueRouter({
  // mode: 'history',
  mode:'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
